import { render, staticRenderFns } from "./IotGatewayTooltip.vue?vue&type=template&id=61a6465c&lang=pug&"
import script from "./IotGatewayTooltip.vue?vue&type=script&lang=ts&"
export * from "./IotGatewayTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports